import axios from 'axios';
import { Navigate } from 'react-router-dom';
import { useState, useEffect } from 'react';

const PrivateRoute = ({ children }) => {
  const [isValidToken, setIsValidToken] = useState(null);
  const accessToken = localStorage.getItem('accessToken');

  useEffect(() => {
    const validateToken = async () => {
      if (!accessToken) {
        setIsValidToken(false);
        return;
      }

      try {
        const apiUrl = process.env.NODE_ENV === 'production' ? 'https://testone.conversationaily.ai' : 'https://consult.conversationaily.ai/api/pre-scenario/data';
        await axios.get(`${apiUrl}/api/validate-token`, {
          headers: { Authorization: `Bearer ${accessToken}` }
        });
        setIsValidToken(true);
        axios.defaults.headers.common['Authorization'] = `Bearer ${accessToken}`;
      } catch (error) {
        localStorage.removeItem('accessToken');
        localStorage.removeItem('userName');
        setIsValidToken(false);
      }
    };

    validateToken();
  }, [accessToken]);

  if (isValidToken === null) return <div>Loading...</div>;
  return isValidToken ? children : <Navigate to="/" />;
};

export default PrivateRoute;